export const initialState = {
  request: null,
  loading: false,
  uploadLoading: false,
  error: null,
  uploadError: null,
  uploadSuccess: false,
  uploadedDocument: {},
  storageRequest: null,
  uploadRequest: null,
  downloadedDocument: null,
  downloadLoading: false,
  downloadError: null,
  stampings: [],
  emeteraiStamping: {},
  nextTokens: { 1: null },
  retryLoading: false,
  retryError: null,
  retryStamp: {},
  deleteLoading: false,
  deleteError: null,
  deletedFile: {},
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case "REQUEST_UPLOAD_DOCUMENT":
      return {
        ...state,
        uploadLoading: true,
        uploadError: null,
        uploadSuccess: false,
        uploadRequest: null,
        storageRequest: null,
      };
    case "UPLOAD_DOCUMENT_PENDING":
      return {
        ...state,
        uploadLoading: true,
        uploadError: null,
        uploadSuccess: false,
        storageRequest: action.payload.upload,
        progressUpload: action.payload.progress,
      };
    case "CREATE_DOCUMENT_PENDING":
      return {
        ...state,
        uploadLoading: true,
        uploadError: null,
        uploadSuccess: false,
        storageRequest: null,
        uploadRequest: action.payload.req,
      };
    case "UPLOAD_DOCUMENT_SUCCESS":
      return {
        ...state,
        uploadLoading: false,
        uploadSuccess: true,
        uploadedDocument: action.payload.document,
      };
    case "UPLOAD_DOCUMENT_ERROR":
      return {
        ...state,
        uploadLoading: false,
        uploadError: action.error,
      };
    case "REQUEST_LIST_EMETERAI_STAMPING":
      return {
        ...state,
        request: action.payload.request,
        stampings: [],
        nextTokens:
          action.payload.page === 1
            ? initialState.nextTokens
            : state.nextTokens,
        nextToken: null,
        loading: true,
        error: null,
      };
    case "LIST_EMETERAI_STAMPING_SUCCESS":
      return {
        ...state,
        stampings: action.payload.stampings,
        nextTokens: {
          ...state.nextTokens,
          [action.payload.nextPage]: action.payload.nextToken,
        },
        loading: false,
        request: null,
      };
    case "LIST_EMETERAI_STAMPING_ERROR":
      return {
        ...state,
        loading: false,
        error: action.error,
        request: null,
      };
    case "REQUEST_GET_EMETERAI_STAMPING":
      return {
        ...state,
        emeteraiStamping: {},
        error: null,
        loading: true,
      };
    case "GET_EMETERAI_STAMPING_SUCCESS":
      return {
        ...state,
        emeteraiStamping: action.payload.emeteraiStamping,
        loading: false,
      };
    case "GET_EMETERAI_STAMPING_ERROR":
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    case "REQUEST_DOWNLOAD_DOCUMENT":
      return {
        ...state,
        downloadLoading: true,
        downloadError: null,
      };
    case "DOWNLOAD_DOCUMENT_SUCCESS":
      return {
        ...state,
        downloadLoading: false,
        downloadedDocument: action.payload.downloadedDocument,
      };
    case "DOWNLOAD_DOCUMENT_ERROR":
      return {
        ...state,
        downloadLoading: false,
        downloadError: action.error,
      };
    case "REQUEST_RETRY_STAMP":
      return {
        ...state,
        request: action.payload.request,
        retryLoading: true,
        retryError: null,
      };
    case "RETRY_STAMP_SUCCESS":
      return {
        ...state,
        request: null,
        retryLoading: false,
        retryStamp: action.payload.retryStamp,
      };
    case "RETRY_STAMP_ERROR":
      return {
        ...state,
        request: null,
        retryLoading: false,
        retryError: action.error,
      };
    case "CLEAR_UPLOAD_DOCUMENT":
      return {
        ...state,
        uploadSuccess: false,
        uploadedDocument: {},
      };
    case "CLEAR_RETRY_STAMP":
      return {
        ...state,
        retryError: null,
        retryStamp: {},
      };
    case "REQUEST_DELETE_EMETERAI_FILE":
      return {
        ...state,
        request: action.payload.request,
        deleteLoading: true,
        deleteError: null,
      };
    case "DELETE_EMETERAI_FILE_SUCCESS":
      return {
        ...state,
        request: null,
        deleteLoading: false,
        deletedFile: action.payload.deletedFile,
      };
    case "DELETE_EMETERAI_FILE_ERROR":
      return {
        ...state,
        request: null,
        deleteLoading: false,
        deleteError: action.error,
      };
    case "CLEAR_DELETE_STAMPING":
      return {
        ...state,
        deleteError: null,
        deletedFile: {},
      };
    default:
      return state;
  }
};
